import { Map } from 'immutable';
import simpleStore from '../../../stores/simpleStore';
import reducers from '../reducers';

const INITIAL_STATE = Map.of();

export default simpleStore('ForgotPassword').bind(null, reducers, INITIAL_STATE);
